import type { ResolvedValues, ResolveValuePermutations } from '../type/common/types';
export const calculateCrossProductOfResolvedValues = <Types,>(valuesMappedToAlias: {
  [alias: string]: ResolvedValues<Types>;
}): ResolveValuePermutations<Types> => {
  const aliasesWithValue = Object.entries(valuesMappedToAlias);
  if (aliasesWithValue.length === 0) {
    return [];
  }
  const allResolvedValueArrays = aliasesWithValue.map(alias => alias[1]);
  const combinations = cartesianProduct(allResolvedValueArrays);
  return combinations.map(combination => {
    const result: ResolveValuePermutations<Types>[number] = {};
    aliasesWithValue.forEach(([alias], index) => {
      const value = combination[index];
      if (value !== undefined) {
        result[alias] = value;
      }
    });
    return result;
  });
};
const cartesianProduct = <Types,>(arrays: ResolvedValues<Types>[]): ResolvedValues<Types>[] => {
  if (arrays.length === 0) {
    return [[]];
  }
  const [first, ...rest] = arrays;
  if (!first) {
    return [];
  }
  const restProduct = cartesianProduct(rest);
  const result: ResolvedValues<Types>[] = [];
  for (const item of first) {
    for (const combination of restProduct) {
      result.push([item, ...combination]);
    }
  }
  return result;
};